export const modalStyle = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90vw',
    height: '90vh',
    bgcolor: 'background.paper',
    border: '2px solid #004652',
    color: '#004652',
    boxShadow: 24,
    p: 4,
};
